"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    return "hello world";
}
exports.default = default_1;
